import { useMutation } from "react-query";
import { axiosDefaultApi } from "src/lib/axios";
import { MutationConfig, queryClient } from "src/lib/react-query";
import useNotification from "src/store/Notifications/useNotification";


const deleteBilling = ({ billingId, dataLineID }: { billingId: number, dataLineID:number }): Promise<string> => {
  return axiosDefaultApi.delete(`/api/Billing/DeleteDataForDataLine/${billingId}`);
};

type QueryFnType = typeof deleteBilling;

type UseDeleteBillingOptions = {
  billingId: number;
  dataLineID: number;
  config?: MutationConfig<QueryFnType>;
};

export const useDeleteBilling = ({ config, dataLineID }: UseDeleteBillingOptions) => {
  const { addNotification, setIsNotificationVisible } = useNotification();
  return useMutation({
    onError: (error: any) => {
      addNotification(`Υπήρξε κάποιο πρόβλημα στην διαγραφή του Ελέγχου.`, 500);
      console.error("Couldnt delete Billing", error);
      setIsNotificationVisible(true);
    },
    onSuccess: () => {
      queryClient.invalidateQueries([`getAllBillingsViaDataLineID_${dataLineID}`]);
      addNotification(`Ο Έλεγχος Διαγράφηκε.`, 200);
      setIsNotificationVisible(true);
    },
    ...config,
    mutationFn: deleteBilling,
  });
};
